import type { MakeCall } from '../createMakeCall';

export interface ValidateBillingDataResponse {
  hasCompleteBillingInformation: boolean;
}

const validateBillingInformation = (makeCall: MakeCall) => (userId: number) =>
  makeCall<ValidateBillingDataResponse>(
    'GET',
    `/api/v2/user/${userId}/validate-billing-details`,
  );

export { validateBillingInformation };

export type ValidateBillingInformation = ReturnType<
  typeof validateBillingInformation
>;
